/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useActiveAccountQuery } from "./useActiveAccountQuery";
import { useSelectedAccountQuery } from "./useSelectedAccountQuery";

/**
 * App-global side effect that keeps the MyFarmlands "active account" in sync with the
 * selected farmer account. Delegates to the account-keyed {@link useActiveAccountQuery},
 * so it shares one request with any feature provider mounted at the same time.
 */
export const useSetActiveAccount = (): void => {
  const { selectedAccount } = useSelectedAccountQuery();
  useActiveAccountQuery(selectedAccount?.accountNumber ?? null);
};
